import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { LibreriaGuard } from "./guards/libreria.guard";
import { HomeGuard } from "./guards/home.guard";
import { PrivateLayoutComponent } from "./layout/private-layout/private-layout.component";
import { PublicLayoutComponent } from "./layout/public-layout/public-layout.component";
import { InitialRedirectGuard } from "./guards/initial-redirect.guard";

const routes: Routes = [
  {
    path: "",
    canActivate: [InitialRedirectGuard],
    children: [],
  },
  {
    path: "auth",
    component: PublicLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
      },
      {
        path: "login",
        loadChildren: () =>
          import("./login/login.module").then((m) => m.LoginPageModule),
      },
      {
        path: "register",
        loadChildren: () =>
          import("./register/register.module").then(
            (m) => m.RegisterPageModule
          ),
      },
      {
        path: "recuperar-contrasena",
        loadChildren: () =>
          import("./recuperar-contrasena/recuperar-contrasena.module").then(
            (m) => m.RecuperarContrasenaModule
          ),
      },
      {
        path: "register/:code",
        loadChildren: () =>
          import("./register/register.module").then(
            (m) => m.RegisterPageModule
          ),
      },
      {
        path: "contac",
        loadChildren: () =>
          import("./contactanos/contactanos.module").then(
            (m) => m.ContactanosPageModule
          ),
      },
      {
        path: "whoAre",
        loadChildren: () =>
          import("./quienes-somos/quienes-somos.module").then(
            (m) => m.QuienesSomosPageModule
          ),
      },
      {
        path: "work",
        loadChildren: () =>
          import("./trabaja-nosotros/trabaja-nosotros.module").then(
            (m) => m.TrabajNosotrosPageModule
          ),
      },
      {
        path: "ask",
        loadChildren: () =>
          import("./preguntas/preguntas.module").then(
            (m) => m.PreguntasPageModule
          ),
      },
      {
        path: "termi",
        loadChildren: () =>
          import("./terminos/terminos.module").then(
            (m) => m.TerminosPageModule
          ),
      },
      {
        path: "trata",
        loadChildren: () =>
          import("./tratamiento/tratamiento.module").then(
            (m) => m.TratamientoPageModule
          ),
      },
      {
        path: "init",
        loadChildren: () =>
          import("./onboarding/onboarding.module").then(
            (m) => m.OnboardingModule
          ),
        data: { reuse: false },
      },
      { path: "**", redirectTo: "auth" },
    ],
  },
  {
    path: "",
    component: PrivateLayoutComponent,
    canActivate: [HomeGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./tabs/tabs.module").then((m) => m.TabsPageModule),
      },
      { path: "**", redirectTo: "cursos" },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
